module.exports = __webpack_public_path__ + "img/bullet.2a4c8ac0.svg";